import slugify from "slugify";

const US_STATES: Record<string, string> = {
  AL: "Alabama",
  AK: "Alaska",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  DC: "District of Columbia",
  FL: "Florida",
  GA: "Georgia",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming",
};

const CANADIAN_PROVINCES: Record<string, string> = {
  AB: "Alberta",
  BC: "British Columbia",
  MB: "Manitoba",
  NB: "New Brunswick",
  NL: "Newfoundland and Labrador",
  NS: "Nova Scotia",
  NT: "Northwest Territories",
  NU: "Nunavut",
  ON: "Ontario",
  PE: "Prince Edward Island",
  QC: "Quebec",
  SK: "Saskatchewan",
  YT: "Yukon",
};

const REGION_NAMES: Record<string, Record<string, string>> = {
  US: US_STATES,
  CA: CANADIAN_PROVINCES,
};

const placeSlug = (name: string) => slugify(name, { lower: true });

/**
 * Documents write a state as "FL" or "Florida"; the catalog slugs the full
 * name. Returns the slug to look up.
 */
export function regionSlug(state: string, countryCode: string): string {
  const trimmed = state.trim();
  const name = REGION_NAMES[countryCode]?.[trimmed.toUpperCase()] ?? trimmed;
  return placeSlug(name);
}

export const citySlug = (city: string) => placeSlug(city.trim());

export interface BuyBoxPlace {
  id: number;
  level: number;
  ancestorIds: number[];
}

/**
 * Buy box areas the target could be in because its documents don't say where
 * precisely. A target known only as "Florida" may or may not be in a Tampa buy
 * box, so that is unknown rather than a miss. A place at a level the target's
 * chain does have (another city, another state) is a real miss.
 */
export function possibleBuyBoxSubdivisionIds(
  target: Array<{ id: number; level: number }>,
  buyBoxPlaces: BuyBoxPlace[],
): number[] {
  const targetIds = new Set(target.map((place) => place.id));
  const targetLevels = new Set(target.map((place) => place.level));
  return buyBoxPlaces
    .filter((place) => {
      if (targetIds.has(place.id)) return false;
      if (target.length === 0) return true;
      return (
        !targetLevels.has(place.level) &&
        place.ancestorIds.some((id) => targetIds.has(id))
      );
    })
    .map((place) => place.id);
}
